import { render, staticRenderFns } from "./exportblk3.vue?vue&type=template&id=dc2a02ae"
import script from "./exportblk3.vue?vue&type=script&lang=js"
export * from "./exportblk3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports